export const GET_ALL_COMMENTS = "GET-ALL-COMMENTS";
